module.exports = __webpack_public_path__ + "static/media/upgrade.ab0a9a53.svg";